var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCasinoIcon = function SvgCasinoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.833 10.69a2.501 2.501 0 1 0-1.666 0v5.143H27.5V12.5c0-.92-.746-1.667-1.667-1.667h-1.597c-.595 0-1.132-.328-1.5-.795A6.66 6.66 0 0 0 17.5 7.5a6.66 6.66 0 0 0-5.235 2.538c-.369.467-.906.795-1.501.795H9.167c-.92 0-1.667.746-1.667 1.667v20c0 .92.746 1.666 1.667 1.666h16.666c.92 0 1.667-.746 1.667-1.666v-8.334h1.667c.92 0 1.666-.746 1.666-1.666V10.69M11.667 27.5a.833.833 0 1 0 0 1.666h11.666a.833.833 0 1 0 0-1.666zm-.834-11.666c0-.92.746-1.667 1.666-1.667h10c.92 0 1.667.746 1.667 1.667V22.5c0 .92-.746 1.667-1.667 1.667h-10c-.92 0-1.666-.746-1.666-1.667z",
    clipRule: "evenodd"
  })));
};
export default SvgCasinoIcon;